var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.announceType === 'info' ? 'info' : 'warning', 'announcement']},[(_vm.announceType === 'info')?_c('img',{staticClass:"announcement-icon",attrs:{"src":require("./assets/clock.svg"),"alt":"审核中"}}):_c('img',{staticClass:"announcement-icon",attrs:{"src":require("./assets/warning-red.svg"),"alt":"警告"}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }